import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", { class: "w-100 sm-fs-sm" }, " Password ", -1)
const _hoisted_2 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_3 = { class: "w-full d-flex flex-md-row gap-20 align-items-end flex-column" }
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock("form", {
    id: "password-change-form",
    class: "form account-settings",
    onKeypress: _cache[4] || (_cache[4] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]), ["enter"]))
  }, [
    _hoisted_1,
    (_ctx.errors && _ctx.errors.General?.length)
      ? (_openBlock(), _createElementBlock("small", _hoisted_2, _toDisplayString(_ctx.errors?.General?.join(' ')), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_TextInput, {
        type: "password",
        label: "Current Password",
        placeholder: "Enter your Current password",
        modelValue: _ctx.currentPassword,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPassword) = $event)),
        error: _ctx.errors?.current_password ?? null,
        errorPlacement: "top",
        displayErrorMessage: false
      }, null, 8, ["modelValue", "error"]),
      _createVNode(_component_TextInput, {
        type: "password",
        label: "New Password",
        placeholder: "Enter New password",
        modelValue: _ctx.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
        name: "password",
        error: _ctx.errors?.password ?? null,
        errorPlacement: "top",
        displayErrorMessage: false
      }, null, 8, ["modelValue", "error"]),
      _createVNode(_component_TextInput, {
        type: "password",
        label: "Confirm New Password",
        placeholder: "Enter Confirm New password",
        modelValue: _ctx.passwordConfirmation,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.passwordConfirmation) = $event)),
        name: "password_confirmation",
        error: _ctx.errors?.password_confirmation ?? null,
        displayErrorMessage: false,
        errorPlacement: "top"
      }, null, 8, ["modelValue", "error"]),
      _createElementVNode("button", {
        type: "submit",
        class: _normalizeClass(["btn toggle-control lh-sm", {'btn-primary': !_ctx.isButtonSubmitDisabled, 'btn-secondary': _ctx.isButtonSubmitDisabled}]),
        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
        disabled: _ctx.loadingUpdate || _ctx.isButtonSubmitDisabled
      }, " Update ", 10, _hoisted_4)
    ])
  ], 32))
}